import * as React from 'react';
import {Route, Routes} from "react-router";
import Layout from "./layouts/layout";
import LoginPage from "./pages/login";
import Public from "./layouts/public";
import NotFoundPage from "./pages/notfound";
import Secure from "./layouts/secure";
import DashboardPage from "./pages/dashboard/dashboard";
import {AuthProvider} from "./providers/auth";
import BlockedPublishersPage from "./pages/blockedPublishers/blockedPublishers";
import IpLookupPage from "./pages/ipLookup";
import ClickFeedImportedPage from "./pages/clickFeedImported";
import ClickFeedStatsPage from "./pages/clickFeedStats";
import InventoryStatsPage from "./pages/inventoryStats";
import ClickFeedCampaignsPage from "./pages/clickFeedCampaigns";
import PublishersPage from "./pages/publishers/publishers";
import PublisherPage from "./pages/publisher";
import PublisherCreditsPage from "./pages/publisherCredits/publisherCredits";
import BrokersPage from "./pages/brokers/brokers";
import CompaniesPage from "./pages/companies/companies";
import RevenueCalendarPage from "./pages/revenueCalendar";
import RulesPage from './pages/rules/rules';
import RuleFailsPage from './pages/rules/ruleFails';
import SchoolsPage from './pages/schools/schools';
import UsersPage from './pages/users/users';
import SeoSchoolsPage from "./pages/seo/seoSchools";
import SeoYearPage from "./pages/seo/seoYear";
import SeoRankingsPage from "./pages/seo/seoRankings";
import SeoRankingPage from "./pages/seo/seoRanking";
import GclidRevenuePage from "./pages/google/gclidRevenue";
import ClickWallSchoolsPage from "./pages/clickwall/clickWallSchools";
import ClickWallProgramsPage from "./pages/clickwall/clickWallPrograms";
import ClickWallProgramMapsPage from "./pages/clickwall/clickWallProgramMaps";
import WindowsDashboardPage from "./pages/dashboard/windows/dashboard";
import LegalDashboardPage from "./pages/dashboard/legal/dashboard";
import AutoDashboardPage from "./pages/dashboard/auto/dashboard";
import ApiUsagePage from "./pages/apiUsage";
import ClickWallLeaderboard from "./pages/clickwall/clickWallLeaderboard";
import ZipUpload from "./pages/zipUpload";
import ReportCardsPage from "./pages/reportCards";
import TTDashboardPage from "./pages/dashboard/tt/dashboard";
import PhoneUpload from "./pages/phoneUpload";
import MortgadeDashboardPage from "./pages/dashboard/mortgage/dashboard";
import IpUpload from "./pages/ipUpload";
import ClickWallDialerStatsPage from "./pages/clickWallDialerStats";
import WebsitesPage from "./pages/websites/websites";
import MarginUpdatesPage from "./pages/marginUpdates";
import CostQueuePage from "./pages/costQueue/costQueue";
import CakeWeeklyPage from "./pages/cake/cakeWeekly";
import CakeMonthlyPage from "./pages/cake/cakeMonthly";
import ProgramSetsPage from "./pages/programSets/programSets";
import ProgramSetPage from "./pages/programSets/programSet";
import ProgramSetProgramsPage from "./pages/programSets/programSetPrograms";
import CampaignConfirmsPage from "./pages/campaignConfirms/campaignConfirms";
import FingerprintPage from "./pages/fingerprint/fingerprint";
import UnsubscribePage from "./pages/leads/unsubscribe";
import LeadLookupPage from "./pages/leads/leadLookup";
import UploadConversionsPage from "./pages/leads/uploadConversions";
import SetCapsPage from "./pages/hp/setCaps";
import GroupCapsPage from "./pages/groupCaps/groupCaps";
import CampaignUpsertPage from "./pages/campaigns/campaignUpsert";
import HpCampaignsPage from "./pages/campaigns/hpCampaigns";
import BillablesPage from "./pages/billables/billables";
import EventUpsertPage from "./pages/events/eventUpsert";
import EventFieldsPage from "./pages/events/eventFields";
import PortalRedirectCampaignsPage from "./pages/portalRedirect/portalRedirectCampaigns";
import ConversionStatsLinkoutPage from "./pages/conversionStats/conversionStatsLinkout";

export default function App() {
    return (
        <AuthProvider>
            <Routes>
                <Route element={<Layout />}>
                    <Route element={<Public />}>
                        <Route path="/" element={<LoginPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Route>
                    <Route element={<Secure />}>
                        <Route path="/dashboard" element={<DashboardPage />} />
                        <Route path="/blockedPubs" element={<BlockedPublishersPage />} />
                        <Route path="/ipLookup" element={<IpLookupPage />} />
                        <Route path="/clickFeedCampaigns" element={<ClickFeedCampaignsPage />} />
                        <Route path="/clickFeedImported" element={<ClickFeedImportedPage />} />
                        <Route path="/clickFeedStats" element={<ClickFeedStatsPage />} />
                        <Route path="/inventory" element={<InventoryStatsPage />} />
                        <Route path="/publishers" element={<PublishersPage />} />
                        <Route path="/publishers/:id" element={<PublisherPage />} />
                        <Route path="/brokers" element={<BrokersPage />} />
                        <Route path="/schools" element={<SchoolsPage />} />
                        <Route path="/companies" element={<CompaniesPage /> } />
                        <Route path="/publisherCredits" element={<PublisherCreditsPage />} />
                        <Route path="/revenueCalendar" element={<RevenueCalendarPage />} />
                        <Route path="/rules" element={<RulesPage />} />
                        <Route path="/rules/fails" element={<RuleFailsPage />} />
                        <Route path="/users" element={<UsersPage />} />
                        <Route path="/seoSchools" element={<SeoSchoolsPage />} />
                        <Route path="/seoYear/:year" element={<SeoYearPage />} />
                        <Route path="/seoRankings/:year" element={<SeoRankingsPage />} />
                        <Route path="/seoRanking/:id" element={<SeoRankingPage />} />
                        <Route path="/gclidRevenue" element={<GclidRevenuePage />} />
                        <Route path="/clickWallSchools" element={<ClickWallSchoolsPage />} />
                        <Route path="/clickWallPrograms/:school_id" element={<ClickWallProgramsPage />} />
                        <Route path="/clickWallProgramMaps/:school_id/:program_id" element={<ClickWallProgramMapsPage />} />
                        <Route path="/clickWallLeaderboard" element={<ClickWallLeaderboard />} />
                        <Route path="/windows" element={<WindowsDashboardPage />} />
                        <Route path="/legal" element={<LegalDashboardPage />} />
                        <Route path="/auto" element={<AutoDashboardPage />} />
                        <Route path="/tt" element={<TTDashboardPage />} />
                        <Route path="/mortgage" element={<MortgadeDashboardPage />} />
                        <Route path="/apiUsage" element={<ApiUsagePage />} />
                        <Route path="/zipUpload" element={<ZipUpload />} />
                        <Route path="/ipUpload" element={<IpUpload />} />
                        <Route path="/phoneUpload" element={<PhoneUpload />} />
                        <Route path="/reportCards" element={<ReportCardsPage/>} />
                        <Route path="/dialerStats" element={<ClickWallDialerStatsPage />} />
                        <Route path="/websites" element={<WebsitesPage />} />
                        <Route path="/marginUpdates" element={<MarginUpdatesPage />} />
                        <Route path="/costQueue" element={<CostQueuePage/>} />
                        <Route path="/cakeWeekly" element={<CakeWeeklyPage />} />
                        <Route path="/cakeMonthly" element={<CakeMonthlyPage />} />
                        <Route path="/programSets" element={<ProgramSetsPage />} />
                        <Route path="/programSets/:id" element={<ProgramSetPage />} />
                        <Route path="/programSets/:id/programs" element={<ProgramSetProgramsPage />} />
                        <Route path="/campaignConfirms/:hpCampaignId" element={<CampaignConfirmsPage />} />
                        <Route path="/fingerprint" element={<FingerprintPage />} />
                        <Route path="/unsubscribe" element={<UnsubscribePage />} />
                        <Route path="/lead" element={<LeadLookupPage />} />
                        <Route path="/uploadConversions" element={<UploadConversionsPage />} />
                        <Route path="/uploadConversionsLO" element={<UploadConversionsPage />} />
                        <Route path="/setCaps" element={<SetCapsPage />} />
                        <Route path="/groupCaps" element={<GroupCapsPage />} />
                        <Route path="/campaigns" element={<HpCampaignsPage />} />
                        <Route path="/campaigns/new" element={<CampaignUpsertPage />} />
                        <Route path="/campaigns/:id" element={<CampaignUpsertPage />} />
                        <Route path="/createCampaign" element={<CampaignUpsertPage />} />
                        <Route path="/billables" element={<BillablesPage />} />
                        <Route path="/events/new" element={<EventUpsertPage />} />
                        <Route path="/events/:eventId/fields" element={<EventFieldsPage />} />
                        <Route path="/events/:id" element={<EventUpsertPage />} />
                        <Route path="/createEvent" element={<EventUpsertPage />} />
                        <Route path="/portalRedirectCampaigns" element={<PortalRedirectCampaignsPage />} />
                        <Route path="/conversionStatsLinkout" element={<ConversionStatsLinkoutPage />} />
                    </Route>
                </Route>

            </Routes>
        </AuthProvider>
    );
}
